/**
 * @generated SignedSource<<382b104e701c3a57d39cbef7553b0a6b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveITPBanks_charge$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveITPBanksList_charge">;
  readonly " $fragmentType": "PaymentActiveITPBanks_charge";
};
export type PaymentActiveITPBanks_charge$key = {
  readonly " $data"?: PaymentActiveITPBanks_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveITPBanks_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveITPBanks_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveITPBanksList_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "5c69fb974dc8aabbeaa01996a5c20d5b";

export default node;
